import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import type {
	UserIdType,
	BusinessObjectTypeType,
	ModuleIdType,
	BusinessObjectIdType,
} from '../types.js'
import {
	jsonArrayProperty,
	jsonProperty,
	jsonClass,
} from '@sumbricht/json-class-serializer'

@jsonClass('UserPermission')
export class UserPermission {
	@jsonProperty(Number)
	id?: number

	userId?: UserIdType

	@jsonProperty(String)
	permissionModuleId: ModuleIdType = ''

	@jsonProperty(String)
	permissionBoId: BusinessObjectIdType = ''

	@jsonArrayProperty(String)
	tenantIds: string[] = []
	@jsonProperty(Boolean)
	appliesAlsoToSubTenants: boolean = true

	constructor(init?: Partial<UserPermission>) {
		assignCommonProperties(this, init)
	}

	static fromQualifiedName(qualifiedName: string) {
		const [permissionModuleId, permissionBoId] = qualifiedName.split('.')
		return new UserPermission({ permissionModuleId, permissionBoId })
	}

	getQualifiedTypeAndName() {
		return `Permission:${this.getQualifiedName()}`
	}

	getQualifiedName() {
		return `${this.permissionModuleId}.${this.permissionBoId}`
	}

	matches(other: UserPermission) {
		return (
			this.permissionModuleId === other.permissionModuleId &&
			this.permissionBoId === other.permissionBoId
		)
	}
}
